import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import FirstChart from "../../components/Charts/FirstChart";
import SecondChart from "../../components/Charts/SecondChart";
import ThirdChart from "../../components/Charts/ThirdChart";
import FourthChart from "../../components/Charts/FourthChart";
import { Container } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  paddingTop: "5px",
  boxShadow: theme.shadows[4], // Usando el shadow del tema
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const GridContainer = styled(Grid)(({ theme }) => ({
  minHeight: "calc(40vh - 32px)", 
}));

export default function Dashboard() {
  return (
      <Box id="BOXPPAL" sx={{ flex: 1, marginTop: "4%" }}>
        <GridContainer
          id="GRIDPPAL"
          container
          rowSpacing={3}
          columnSpacing={{ xs: 2, sm: 3, md: 4 }}
        >
          <Grid xs={12} sm={6}>
            <Item elevation={4}>
              <FirstChart />
            </Item>
          </Grid>
          <Grid xs={12} sm={6}>
            <Item elevation={4}>
              <SecondChart />
            </Item>
          </Grid>
          <Grid xs={12} sm={6}>
            <Item elevation={4}>
              <ThirdChart />
            </Item>
          </Grid>
          <Grid xs={12} sm={6}>
            <Item elevation={4}>
              <FourthChart />
            </Item>
          </Grid>
        </GridContainer>
      </Box>
  );
}
